import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/contexts/I18nContext";
import MapView from "@/components/MapView";

export default function MapPage() {
  const { t, tx } = useI18n();
  const [data, setData] = useState(null);
  const [activeCats, setActiveCats] = useState(new Set());

  useEffect(() => {
    api.get("/map/main").then(r => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return <div className="max-w-7xl mx-auto px-5 py-20 text-muted-foreground">{t.common.loading}</div>;

  const filtered = activeCats.size === 0
    ? data
    : { ...data, markers: data.markers.filter(m => activeCats.has(m.category?.id)) };

  const toggle = (id) => {
    const next = new Set(activeCats);
    if (next.has(id)) next.delete(id); else next.add(id);
    setActiveCats(next);
  };

  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-10 md:py-12">
      <h1 className="font-display text-4xl md:text-5xl font-semibold tracking-tight">{t.sections.mapTitle}</h1>
      <p className="mt-2 text-muted-foreground">{t.sections.mapSub}</p>

      {/* Filters */}
      <div className="mt-6 flex flex-wrap gap-2">
        {data.categories.map(c => {
          const on = activeCats.has(c.id);
          return (
            <button
              key={c.id}
              onClick={() => toggle(c.id)}
              data-testid={`map-filter-${c.type}`}
              className={`px-4 py-2 rounded-full text-sm font-medium transition border ${
                on
                  ? c.color === "red" ? "bg-[hsl(var(--primary-red))] text-white border-transparent" : "bg-[hsl(var(--primary-green))] text-white border-transparent"
                  : "bg-white border-border hover:bg-muted"
              }`}
            >
              {tx(c.name)}
            </button>
          );
        })}
      </div>

      <div className="mt-6">
        <MapView data={filtered} height="72vh" />
      </div>
    </div>
  );
}
